import { render } from "./Banner.vue?vue&type=template&id=8cc57fa4"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=8cc57fa4&lang=scss"
script.render = render

export default script